import type { EncounterDef } from '../types';

export const ENCOUNTERS: EncounterDef[] = [
  {
    id: 'forestWalk',
    name: { en: 'Forest Walk', pt: 'Caminhada na Floresta' },
    flavor: {
      en: 'A path between birch and silence. Common things grow here.',
      pt: 'Um caminho entre bétulas e silêncio. Coisas comuns crescem aqui.',
    },
    duration: 4,
    unlockXp: 0,
    unlockCoin: 0,
    drops: [
      { id: 'wood', min: 1, max: 2 },
      { id: 'herb', min: 0, max: 1 },
    ],
    xpGain: 1,
    phi: 0.6,
    phiClass: 'conservation',
  },
  {
    id: 'oldMine',
    name: { en: 'Old Mine', pt: 'Mina Antiga' },
    flavor: {
      en: 'Beams creak. Veins of iron persist where the maps say nothing should.',
      pt: 'Vigas rangem. Veios de ferro persistem onde os mapas dizem que não há nada.',
    },
    duration: 6,
    unlockXp: 4,
    unlockCoin: 0,
    drops: [
      { id: 'ore', min: 1, max: 2 },
      { id: 'wood', min: 0, max: 1, chance: 0.3 },
    ],
    xpGain: 2,
    phi: 1.0,
    phiClass: 'conservation',
  },
  {
    id: 'ruinedTower',
    name: { en: 'Ruined Watchtower', pt: 'Torre de Vigia em Ruínas' },
    flavor: {
      en: 'No watch remains, but coin still falls from broken seams.',
      pt: 'Nenhum vigia restou, mas moedas ainda escorrem das fendas.',
    },
    duration: 8,
    unlockXp: 12,
    unlockCoin: 30,
    drops: [
      { id: 'coin', min: 4, max: 9 },
      { id: 'hide', min: 0, max: 1, chance: 0.55 },
    ],
    xpGain: 3,
    phi: 1.4,
    phiClass: 'identity',
  },
  {
    id: 'sourBog',
    name: { en: 'Sour Bog', pt: 'Pântano Azedo' },
    flavor: {
      en: 'Slow water. The air hums between footsteps.',
      pt: 'Água lenta. O ar zumbe entre os passos.',
    },
    duration: 12,
    unlockXp: 35,
    unlockCoin: 0,
    drops: [
      { id: 'herb', min: 1, max: 2 },
      { id: 'hide', min: 0, max: 1, chance: 0.5 },
      { id: 'ether', min: 1, max: 1, chance: 0.08 },
    ],
    xpGain: 5,
    phi: 2.4,
    phiClass: 'causal',
  },
  {
    id: 'banditCamp',
    name: { en: 'Bandit Camp', pt: 'Acampamento de Bandidos' },
    flavor: {
      en: 'They left their coin behind. They will return for it.',
      pt: 'Deixaram a moeda para trás. Voltarão para buscá-la.',
    },
    duration: 18,
    unlockXp: 90,
    unlockCoin: 200,
    drops: [
      { id: 'coin', min: 18, max: 40 },
      { id: 'ore', min: 1, max: 2 },
      { id: 'ether', min: 1, max: 1, chance: 0.04 },
    ],
    xpGain: 9,
    phi: 4.2,
    phiClass: 'semantic',
  },
  {
    id: 'crystalCave',
    name: { en: 'Crystal Cave', pt: 'Caverna de Cristal' },
    flavor: {
      en: 'The shards hum a single note. It does not vary.',
      pt: 'Os fragmentos zumbem uma única nota. Ela não varia.',
    },
    duration: 14,
    unlockXp: 160,
    unlockCoin: 400,
    drops: [
      { id: 'crystal', min: 1, max: 2 },
      { id: 'ether', min: 1, max: 1, chance: 0.12 },
      { id: 'coin', min: 8, max: 16 },
    ],
    xpGain: 8,
    phi: 3.6,
    phiClass: 'identity',
  },
  {
    id: 'silkRoad',
    name: { en: 'Silk Road', pt: 'Rota da Seda' },
    flavor: {
      en: 'A caravan that never seems to arrive. The goods are real.',
      pt: 'Uma caravana que nunca parece chegar. As mercadorias são reais.',
    },
    duration: 22,
    unlockXp: 280,
    unlockCoin: 800,
    drops: [
      { id: 'silk', min: 1, max: 3 },
      { id: 'coin', min: 22, max: 50 },
      { id: 'crystal', min: 0, max: 1, chance: 0.18 },
    ],
    xpGain: 14,
    phi: 6.0,
    phiClass: 'causal',
  },
  {
    id: 'ossuary',
    name: { en: 'Ossuary', pt: 'Ossuário' },
    flavor: {
      en: 'The bones outnumber any plausible kingdom.',
      pt: 'Os ossos excedem qualquer reino plausível.',
    },
    duration: 25,
    unlockXp: 450,
    unlockCoin: 1500,
    drops: [
      { id: 'bone', min: 3, max: 6 },
      { id: 'ether', min: 1, max: 1, chance: 0.2 },
      { id: 'coin', min: 15, max: 30 },
    ],
    xpGain: 18,
    phi: 8.4,
    phiClass: 'semantic',
  },
];

export function encounterById(id: string): EncounterDef | undefined {
  return ENCOUNTERS.find((e) => e.id === id);
}
